export default "__VITE_ASSET__hwGuca2m__"